import { useMemo } from 'react';

import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { useAppQuery } from '../use-app-query.hook';
import { DividendShareClassHolder } from './dividend.types';

export const useDividendShareClassHolders = ({ companyId }: { companyId: string }) => {
  const { data, isLoading } = useAppQuery({
    queryKey: [QueryKey.DIVIDEND_SHARE_CLASS_HOLDERS, companyId],
    queryFn: () =>
      ApiService.get<DividendShareClassHolder[]>({
        endpoint: BackendRoute.DIVIDENDS_SHARE_CLASS_HOLDERS,
      }),
    enabled: !!companyId,
  });

  const holdersByShareClass = useMemo(() => {
    const map = new Map<string, DividendShareClassHolder[]>();
    (data ?? []).forEach((holder) => {
      const group = map.get(holder.shareClassId);
      if (group) group.push(holder);
      else map.set(holder.shareClassId, [holder]);
    });
    return map;
  }, [data]);

  return { holdersByShareClass, isLoading };
};
